import { actionCreator } from 'utils';
import * as OrderItemTypes from '../types/orderItemTypes';

// L O A D   O R D E R   I T E M S
export function loadOrderItems() {
    return {
        type: OrderItemTypes.LOAD_ORDER_ITEMS,
    };
}

export function loadOrderItemsRes(data) {
    return {
        type: actionCreator(OrderItemTypes.LOAD_ORDER_ITEMS, 'res'),
        data,
    };
}

export function loadOrderItemsErr() {
    return {
        type: actionCreator(OrderItemTypes.LOAD_ORDER_ITEMS, 'err'),
    };
}

export function setOrderItemNeededData(data) {
    return {
        type: OrderItemTypes.SET_ORDER_ITEM_NEEDED_DATA,
        data,
    };
}
// L O A D   O R D E R   I T E M S


// S E T   O R D E R   I T E M   F I L T E R S
export function setOrderItemFilters(key, value) {
    return {
        type: OrderItemTypes.SET_ORDER_ITEM_FILTERS,
        key,
        value,
    };
}
// S E T   O R D E R   I T E M   F I L T E R S

// P U T   B U L K   I N   P R O D U C T I O N
export function putBulkInProduction() {
    return {
        type: OrderItemTypes.PUT_BULK_IN_PRODUCTION,
    };
}
// P U T   B U L K   I N   P R O D U C T I O N


// R E S E T   O R D E R   I T E M   F I L T E R S
export function resetOrderItemFilters() {
    return {
        type: OrderItemTypes.RESET_ORDER_ITEM_FILTERS,
    };
}

export function resetOrderItemFiltersRes(data) {
    return {
        type: actionCreator(OrderItemTypes.RESET_ORDER_ITEM_FILTERS, 'res'),
        data,
    };
}
// R E S E T   O R D E R   I T E M   F I L T E R S


// S E T   O R D E R   I T E M   P A G I N A T I O N
export function setOrderItemPagination(key, pagination) {
    return {
        type: OrderItemTypes.SET_ORDER_ITEM_PAGINATION,
        key,
        pagination,
    };
}
// S E T   O R D E R   I T E M   P A G I N A T I O N


// T O G G L E   O R D E R   I T E M   S T A T U S
export function toggleOrderItemStatus(data) {
    return {
        type: OrderItemTypes.TOGGLE_ORDER_ITEM_STATUS,
        data,
    };
}
// T O G G L E   O R D E R   I T E M   S T A T U S

// S H O W   P U T   B U L K   I N   P R O D U C T I O N   C O N F I R M A T I O N   P O P U P
export function showPutBulkInProductionConfirmationPopup() {
    return {
        type: OrderItemTypes.SHOW_PUT_BULK_IN_PRODUCTION_CONFIRMATION_POPUP,
    };
}

export function hidePutBulkInProductionConfirmationPopup() {
    return {
        type: OrderItemTypes.HIDE_PUT_BULK_IN_PRODUCTION_CONFIRMATION_POPUP,
    };
}
// S H O W   P U T   B U L K   I N   P R O D U C T I O N   C O N F I R M A T I O N   P O P U P


// T O G G L E   S T A T U S   C O N F I R M A T I O N   P O P U P
export function showToggleStatusConfirmationPopup() {
    return {
        type: OrderItemTypes.SHOW_TOGGLE_STATUS_CONFIRMATION_POPUP,
    };
}

export function hideToggleStatusConfirmationPopup() {
    return {
        type: OrderItemTypes.HIDE_TOGGLE_STATUS_CONFIRMATION_POPUP,
    };
}
// T O G G L E   S T A T U S   C O N F I R M A T I O N   P O P U P


// S E T   C H E C K E D   O R D E R  I T E M S   P R O D U C T I O N
export function setCheckedOrderItemsProduction(id) {
    return {
        type: OrderItemTypes.SET_CHECKED_ORDER_ITEMS_PRODUCTION,
        id,
    };
}
// S E T   C H E C K E D   O R D E R  I T E M S   P R O D U C T I O N


// S E T   O R D E R  I T E M   C O M M E N T
export function setOrderItemComment(data) {
    return {
        type: OrderItemTypes.SET_ORDER_ITEM_COMMENT,
        data,
    };
}

export function setOrderItemCommentRes(loading, success) {
    return {
        type: actionCreator(OrderItemTypes.SET_ORDER_ITEM_COMMENT, 'res'),
        loading,
        success,
    };
}

export function setOrderItemCommentErr(error) {
    return {
        type: actionCreator(OrderItemTypes.SET_ORDER_ITEM_COMMENT, 'err'),
        error,
    };
}
// S E T   O R D E R  I T E M   C O M M E N T


// P U S H   R E P R I N T
export function pushReprint(data) {
    return {
        type: OrderItemTypes.PUSH_REPRINT,
        data,
    };
}

export function pushReprintRes(loading, success) {
    return {
        type: actionCreator(OrderItemTypes.PUSH_REPRINT, 'res'),
        loading,
        success,
    };
}

export function pushReprintErr(error) {
    return {
        type: actionCreator(OrderItemTypes.PUSH_REPRINT, 'err'),
        error,
    };
}
// P U S H   R E P R I N T

// D E M A N D   R E P R I N T
export function reprintRequest(data) {
    return {
        type: OrderItemTypes.REPRINT_REQUEST,
        data,
    };
}

export function reprintRequestRes(loading, success) {
    return {
        type: actionCreator(OrderItemTypes.REPRINT_REQUEST, 'res'),
        loading,
        success,
    };
}

export function reprintRequestErr(error) {
    return {
        type: actionCreator(OrderItemTypes.REPRINT_REQUEST, 'err'),
        error,
    };
}
// D E M A N D   R E P R I N T

// L O A D   O R D E R   I T E M S
export function loadOrderItem(id) {
    return {
        type: OrderItemTypes.LOAD_ORDER_ITEM,
        id,
    };
}

export function loadOrderItemRes(data) {
    return {
        type: actionCreator(OrderItemTypes.LOAD_ORDER_ITEM, 'res'),
        data,
    };
}

export function loadOrderItemErr() {
    return {
        type: actionCreator(OrderItemTypes.LOAD_ORDER_ITEM, 'err'),
    };
}

export function emptyOrderItem() {
    return {
        type: OrderItemTypes.EMPTY_ORDER_ITEM,
    };
}

export function setOrderItemPercentage(fragment) {
    return {
        type: OrderItemTypes.SET_ORDER_ITEM_PERCENTAGE,
        fragment,
    };
}
// L O A D   O R D E R   I T E M S


// R E P R I N T
export function setReprintLoading(loading = false) {
    return {
        type: OrderItemTypes.SET_REPRINT_LOADING,
        loading,
    };
}

export function setReprintData(data) {
    return {
        type: OrderItemTypes.SET_REPRINT_DATA,
        data,
    };
}
// R E P R I N T
